<fuse-drawer class="z-999 w-screen min-w-screen sm:w-100 sm:min-w-100" [fixed]="true" [mode]="'over'"
    [name]="'addPlayerDrawer'" [position]="'right'" #addPlayerDrawer>

    <div class="bg-card flex w-full flex-col overflow-auto">
        <!-- Header -->
        <div class="flex h-20 min-h-20 flex-row items-center bg-primary px-6 text-white">
            <mat-icon class="text-current icon-size-7" [svgIcon]="'heroicons_outline:user-group'"></mat-icon>
            <div class="ml-3 text-2xl font-semibold tracking-tight">
                Add Player
            </div>
            <button class="ml-auto" mat-icon-button (click)="addPlayerDrawer.close()">
                <mat-icon class="text-current" [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
            </button>
        </div>

        <!-- Content -->
        <div class="flex flex-col p-6 gap-4">

            <!-- Add Guest Section -->
            <div>
                <button mat-flat-button color="primary" class="w-full flex gap-2" (click)="addGuest()">
                    <mat-icon class="mr-2" [svgIcon]="'heroicons_outline:user-plus'"></mat-icon>
                    <span>Add a Guest</span>
                </button>
            </div>

            <!-- Separator -->
            <div class="flex items-center">
                <div class="flex-auto border-t"></div>
                <div class="text-secondary mx-2 text-sm">OR</div>
                <div class="flex-auto border-t"></div>
            </div>

            <!-- Search Section -->
            <mat-form-field class="w-full" subscriptSizing="dynamic">
                <mat-label>Search by name or phone number</mat-label>
                <input matInput type="text" [(ngModel)]="searchTerm" (ngModelChange)="onSearchChange($event)"
                    placeholder="Start typing to search..." autocomplete="off">
                <mat-icon matPrefix class="icon-size-5 text-hint mr-2"
                    [svgIcon]="'heroicons_outline:magnifying-glass'"></mat-icon>
                @if (searchTerm) {
                <button matSuffix mat-icon-button (click)="clearSearch()" matTooltip="Clear search">
                    <mat-icon class="icon-size-5 text-hint" [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
                </button>
                }
            </mat-form-field>

            <div class="bg-card flex-col gap-2 rounded-lg shadow overflow-hidden">
                <div class="border-b bg-gray-50 p-4 font-semibold text-lg flex justify-between items-center">
                    <span>
                        {{ getListTitle() }}
                    </span>
                </div>

                <div class="p-4 flex flex-col gap-4">
                    @if (isLoading || isHandlingSearch) {
                    <div class="flex justify-center items-center p-8">
                        <mat-progress-spinner diameter="40" mode="indeterminate" color="primary"></mat-progress-spinner>
                    </div>
                    } @else if (getDisplayedUsers().length > 0) {
                    @for (user of getDisplayedUsers(); track user.id) {
                    <div class="flex items-center p-4 bg-gray-50 rounded-lg border border-gray-200 hover:bg-gray-100 cursor-pointer transition-colors"
                        (click)="selectUser(user)">

                        <!-- User Avatar -->
                        <div class="flex-shrink-0 mr-4">
                            @if (getUserImage(user)) {
                            <img class="w-10 h-10 rounded-full object-cover" [src]="getUserImage(user)"
                                [alt]="getUserName(user)">
                            } @else {
                            <div
                                class="w-10 h-10 rounded-full bg-primary bg-opacity-20 flex items-center justify-center">
                                <span class="text-sm font-medium text-primary">
                                    {{ getUserInitials(user) }}
                                </span>
                            </div>
                            }
                        </div>

                        <!-- User Info -->
                        <div class="flex-1 min-w-0">
                            <p class="text-sm font-medium text-gray-900 dark:text-gray-100 truncate">
                                {{ getUserName(user) }}
                            </p>
                            <p class="text-sm text-secondary truncate">
                                {{ user.email }}
                            </p>
                        </div>
                    </div>
                    }
                    }

                </div>
            </div>
        </div>
    </div>
</fuse-drawer>